interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
}

export const MetaTags = ({ 
  title = "PorteroYa - Find the Perfect Goalkeeper for Your Match",
  description = "Connect with qualified goalkeepers in your area. Book with confidence and play with the best. PorteroYa is Spain's premier platform for finding and booking skilled goalkeepers for your football matches.",
  image = "https://porteroya.com/meta/logo-1200x630.jpg"
}: MetaTagsProps) => {
  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://porteroya.com" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://porteroya.com" />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      <meta name="twitter:creator" content="@PorteroYa" />
    </>
  );
};